import { render } from "./ThePageNotFound.vue?vue&type=template&id=609fff9f&ts=true"
import script from "./ThePageNotFound.vue?vue&type=script&lang=ts"
export * from "./ThePageNotFound.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__